import DashboardCard, { DashboardCardValueContent } from "../DashboardCard";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useSelector } from "react-redux";
import { getCases, selectCases, selectLoadingCases } from "app/modules/cases/components/CasesTableSlice";
import { CaseStatusTypes } from "global/enums";
import { useEffect } from "react";
import { ClientPortalCaseFiltersModel } from "services/api/cplapi/CPLAPI";
import { faBriefcase } from "@fortawesome/pro-light-svg-icons";

const YourCasesCard = () => {
  const thunkDispatch = useThunkDispatch();
  const cases = useSelector(selectCases);
  const loadingCases = useSelector(selectLoadingCases);

  useEffect(() => {
    const caseFilters = new ClientPortalCaseFiltersModel({
      includeArchived: false,
    });
    thunkDispatch(getCases({ caseFilters }));
  }, [thunkDispatch]);

  const openCases = cases.filter((c) => c.caseStatusBehaviourType === CaseStatusTypes.Open);

  return (
    <DashboardCard
      key={3}
      title="Your Cases"
      icon={faBriefcase}
      isBusy={loadingCases}
      bodyContent={
        <div>
          <DashboardCardValueContent value={openCases.length} text={"Cases needing your attention"} />
        </div>
      }
      button={{ link: "/Cases", text: "View Cases" }}
      data-test-id="dashboard__view-cases-link"
    />
  );
};

export default YourCasesCard;
